// extracted by mini-css-extract-plugin
export default {"tag":"tag_1Okp","tagRegular":"tagRegular_3MiF","tagWithCount":"tagWithCount_1HU1"};